import * as React from "react";
import classnames from "classnames";

const styles = require('./SuggestList.scss');

export interface Props
{
    items: string[];
    onClick: (item: string, idx: number) => void;

    className?: string;
}

// SuggestList is used to make it easier to attach popular tags to entities
export class SuggestList extends React.Component<Props, any>
{
    render()
    {
        const { items, onClick, className } = this.props;
        
        if(!items || items.length === 0)
            return null;
        
        return (
            <ul className={classnames(className, styles.SuggestList)}>
                {items.map((item, idx) => <li key={idx} onClick={e => onClick(item, idx)}><a>{item}</a></li>)}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/SuggestList/SuggestList.tsx